// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @vowkey/platform/no-enums
export enum ProviderType {
  Msp = 0,
  Reseller = 1,
  BusinessUnit = 2,
}
